import { NgForm } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { GasTwo } from '../../../models/gastwo.model';
import { GasTwoService } from '../../../services/gatwo.service';
import { AccountService } from '../../../services/account.service';
import { fadeInOut } from '../../../services/animations';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { Utilities } from '../../../services/utilities';
import { Permission } from '../../../models/permission.model';
import * as moment from 'moment';

@Component({
    selector: 'gastwo-add-update',
    template: require('./gastwo-add-update.component.html'),
    styles: [require('./gastwo-add-update.component.css')],
    animations: [fadeInOut]
})
export class GasTwoAddUpdateComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    mode: string = "Opslaan";
    gastwo: GasTwo = new GasTwo;
    eanCodes: any[] = [];

    loading: boolean = false;
    display1: boolean = false;
    display2: boolean = false;
    selectedData: any;
    isDisableControl: boolean = false;
    date = new Date();
    ddMonths: [string, string][] = [
        ['Jan', 'Jan'],
        ['Feb', 'Feb'],
        ['Mar', 'Mrt'],
        ['Apr', 'Apr'],
        ['May', 'Mei'],
        ['Jun', 'Jun'],
        ['Jul', 'Jul'],
        ['Aug', 'Aug'],
        ['Sep', 'Sep'],
        ['Oct', 'Okt'],
        ['Nov', 'Nov'],
        ['Dec', 'Dec']];
    selectedMonth: string;
    selectedYear: number;
    years: [string, number][] = [];
    ddYears: [string, number][] = [];

    constructor(private accountService: AccountService, private gastwoService: GasTwoService,
        private router: Router, private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger) {
        this.getYears();
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            if (params['id']) {
                this.gastwo.Id = params['id'];
                this.getById();
            }
        });
        this.gastwo.Date = moment.utc(this.gastwo.Date).toDate()
    }

    private getYears() {
        let currentYear = moment().year();
        this.years.push([(currentYear - 1).toString().substr(2, 2), currentYear - 1]);
        this.years.push([(currentYear).toString().substr(2, 2), currentYear]);
        this.years.push([(currentYear + 1).toString().substr(2, 2), currentYear + 1]);
        this.ddYears = [...this.years];
    }

    private getMonthFromStripName() {
        if (this.gastwo && this.gastwo.StripName) {
            this.selectedMonth = this.gastwo.StripName.substring(0, 3);
            const stripYear = +this.gastwo.StripName.substring(3, this.gastwo.StripName.length);
            if (!this.ddYears.some(s => s[1] === stripYear)) {
                this.ddYears = [];
                this.ddYears = [...this.years];
                const currentYear = new Date().getFullYear();
                const twoCharCurrentYear = +(currentYear.toString().substring(0, 2));
                this.ddYears.splice(0, 0, [(twoCharCurrentYear + '' + stripYear), stripYear]);
            }
            this.selectedYear = stripYear;
        }
    }

    createUpdate(f: NgForm) {
        if (f.form.valid) {
            this.gastwo.StripName = this.selectedMonth + this.selectedYear;
            this.gastwoService.createUpdate(this.gastwo).subscribe((res: GasTwo) => {
                if (res) {
                    if (res.StripName != 'Duplicate') {
                        this.alertService.showMessage('Gas TTF 101', 'Aanpassingen met succes bewaard!', MessageSeverity.success);
                        this.router.navigate(['gastwo']);
                    }
                    else {
                        this.alertService.showMessage('Gas TTF 101', 'waarde bestaat al deze datum!', MessageSeverity.warn);
                    }
                }
            }, error => {
                const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
            });
        }
    }

    getById() {
        this.loading = true;
        const getCustSubscriber = this.gastwoService.getGasTwoById(this.gastwo.Id).subscribe((res: GasTwo) => {
            if (res) {
                this.gastwo = res;
                this.getMonthFromStripName();
                this.loading = false;
                this.subscribers.push(getCustSubscriber);
            }
            else {
                this.router.navigate(['gastwo']);
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    ngOnDestroy(): void {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get canmanagegastwo() {
        return this.accountService.userHasPermission(Permission.manageCustomersPermission);
    }

    onStartDateChange(value: Date) {

        if (moment(value).isAfter(this.gastwo.Date)) {
            this.gastwo.Date = value;
        }

        if (moment(value).isAfter(this.gastwo.StripName)) {
            this.gastwo.StripName = value.toString();
        }
    }

    onStripNameChange(value: Date) {

        if (moment(value).isAfter(this.gastwo.StripName)) {
            this.gastwo.StripName = value.toString();
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas-two/gastwo-addupdate/gastwo-add-update.component.ts